const reviewsSliders = document?.querySelectorAll('.reviews-slider');

const sliderAutoplay = (slider) => {
  let timeout;
  let mouseOver = false;
  function clearNextTimeout() {
    clearTimeout(timeout);
  }
  function nextTimeout() {
    clearTimeout(timeout);
    if (mouseOver) return;
    timeout = setTimeout(() => {
      slider.next();
    }, 2000);
  }
  slider.on('created', () => {
    slider.container.addEventListener('mouseover', () => {
      mouseOver = true;
      clearNextTimeout();
    });
    slider.container.addEventListener('mouseout', () => {
      mouseOver = false;
      nextTimeout();
    });
    nextTimeout();
  });
  slider.on('dragStarted', clearNextTimeout);
  slider.on('animationEnded', nextTimeout);
  slider.on('updated', nextTimeout);
};

reviewsSliders?.forEach((item) => {
  const sliderEl = item?.querySelector('.keen-slider');
  if (sliderEl) {
    const slider = new KeenSlider(
      sliderEl,

      {
        loop: true,
        breakpoints: {
          '(max-width: 1024px)': {
            slides: { perView: 'auto', spacing: 10 },
          },
          '(max-width: 440px)': {
            slides: { perView: 1.25, spacing: 10, origin: 'center' },
          },
        },
        slides: {
          perView: 'auto',
          spacing: 30,
        },
      },
      [
        (slider) => {
          sliderAutoplay(slider);
        },
      ],
    );
  }
});
